import { render, staticRenderFns } from "./FabricInventory.vue?vue&type=template&id=df04903c&"
import script from "./FabricInventory.vue?vue&type=script&lang=js&"
export * from "./FabricInventory.vue?vue&type=script&lang=js&"
import style0 from "./FabricInventory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports